import s from './RegisterBasicPage.module.css';
import { useEffect, useState } from 'react';
import TimezoneSelect from 'react-timezone-select';
import cn from 'classnames';

import ProgressBar from 'components/ProgressBar';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from 'context/AuthContext';

function RegisterBasicPage() {
	const { user } = useAuthContext();

	const [fullName, setFullName] = useState('');
	const [age, setAge] = useState('');

	useEffect(() => {
		if (user && user.hasOwnProperty('description')) {
			setFullName(user.name);
			setAge(user.age);
			setSelectedTimezone({
				label: user.timezone,
				value: user.timezone,
				off_set: user.off_set,
			});
		}
	}, [user]);

	const currentDate = new Date();

	// Get the time zone offset in minutes
	const timeZoneOffset = -Math.floor(currentDate.getTimezoneOffset() / 60);

	const [selectedTimezone, setSelectedTimezone] = useState({
		label:
			`(GMT${timeZoneOffset > 0 ? '+' + timeZoneOffset : timeZoneOffset}) ` +
			Intl.DateTimeFormat().resolvedOptions().timeZone,
		value:
			`(GMT${timeZoneOffset > 0 ? '+' + timeZoneOffset : timeZoneOffset}) ` +
			Intl.DateTimeFormat().resolvedOptions().timeZone,
		off_set: timeZoneOffset,
	});

	const navigate = useNavigate();

	const handleFullName = (e) => {
		setFullName(e.target.value);
	};

	const handleAge = (e) => {
		setAge(e.target.value);
	};

	const handlePrevStep = () => {
		navigate('/');
	};
console.log("TIMEZONE SELECTED: " , selectedTimezone);
	const handleNextStep = (e) => {
		if (fullName !== '' && age !== '') {
			e.preventDefault();
			navigate('/register_detail', {
				state: {
					fullName: fullName,
					age: parseInt(age),
					timeZone: selectedTimezone,
				},
			});
		}
	};

	return (
		<div className={s.root}>
			<ProgressBar step={1} handlePrevStep={handlePrevStep} />
			<div className={s.content}>
				Your registration info cannot be modified during Challenge Period
			</div>
			<form className="w-full md:w-[600px]">
				<div className={s.bottomContent}>
					<div className="w-full">
						<div className="text-[#545252] text-[16px] sm:text-[16px] font-normal ml-3 mb-1">
							Full name
						</div>
						<input
							type="text"
							value={fullName}
							onChange={handleFullName}
							className={s.input2}
							placeholder="Full name"
							required
						/>
					</div>
					<div className="w-full">
						<div className="text-[#545252] text-[16px] sm:text-[16px] font-normal ml-3 mb-1">
							Time zone
						</div>
						<div className={cn(s.select, 'select-wrapper')}>
							<TimezoneSelect
								value={selectedTimezone}
								onChange={setSelectedTimezone}
								className="h-[62px]"
								isSearchable={false}
							/>
						</div>
					</div>
					<div className="w-full">
						<div className="text-[#545252] text-[16px] sm:text-[16px] font-normal ml-3 mb-1">
							Your Age:
						</div>
						<input
							type="number"
							value={age}
							onChange={handleAge}
							className={s.input2}
							placeholder="Your age"
							required
						/>
					</div>
				</div>
				<div
					onClick={handleNextStep}
					className="md:fixed md:bottom-[32px] w-full  md:w-[600px] mt-[90px]"
				>
					<button className={s.continueButton}>Next</button>
				</div>
			</form>
		</div>
	);
}

export default RegisterBasicPage;
